let menuItems = new Map<string, string>();

menuItems.set('P30M', 'Last 30 minutes');
menuItems.set('P1H', 'Last hour')
menuItems.set('P4H', 'Last 4 hours')
menuItems.set('P6H', 'Last 6 hours')
menuItems.set('P12H', 'Last 12 hours')
menuItems.set('P24H', 'Last 24 hours')
menuItems.set('P3D', 'Last 3 days')
menuItems.set('P7D', 'Last 7 days')
menuItems.set('P30D', 'Last 30 days')

export default menuItems;


export function prepareDates(checkedItem: string) {
    const endDate = new Date();
    let startDate = new Date(endDate);
    switch (checkedItem) {
        case 'P30M': {
            startDate.setMinutes(endDate.getMinutes() - 30);
            break;
        }
        case 'P1H': {
            startDate.setMinutes(endDate.getMinutes() - 60);
            break;
        }
        case 'P4H': {
            startDate.setHours(endDate.getHours() - 4);
            break;
        }
        case 'P6H': {
            startDate.setHours(endDate.getHours() - 6);
            break;
        }
        case 'P12H': {
            startDate.setHours(endDate.getHours() - 12);
            break;
        }
        case 'P24H': {
            startDate.setHours(endDate.getHours() - 24);
            break;
        }
        case 'P3D': {
            startDate.setDate(endDate.getDate() - 3);
            break;
        }
        case 'P7D': {
            startDate.setDate(endDate.getDate() - 7);
            break;
        }
        case 'P30D': {
            startDate.setDate(endDate.getDate() - 30);
            break;
        }
        default: {
            startDate.setMinutes(endDate.getMinutes() - 30);
            break;
        }
    }
    return { startDate, endDate };
}